<script lang="ts">
  import { Icon } from '@shared/ui/icon';

  export let isDO = true;
</script>

<article class="dark:text-dark-800 flex w-full flex-col gap-3 text-base font-medium">
  <p class="text-default-900 dark:text-default-50"><strong>Your purchase includes:</strong></p>

  <p class="flex items-start gap-3">
    <Icon name="authenticity" width="{24}" height="{24}" classes="shrink-0" />

    Guaranteed authenticity and full rights protection
  </p>

  <p class="flex items-start gap-3">
    <Icon name="dr" width="{24}" height="{24}" classes="shrink-0" />

    Exclusive rights to own the digital {isDO ? 'original of the artwork' : 'artwork'}
  </p>

  {#if isDO}
    <p class="flex items-start gap-3">
      <Icon name="do" width="{24}" height="{24}" classes="shrink-0" />

      The artwork's ultra-HD image and metadata are securely stored on the blockchain
    </p>
  {:else}
    <p class="flex items-start gap-3">
      <Icon name="blockchain" width="{24}" height="{24}" classes="shrink-0" />

      The artwork's source file and metadata are securely stored on the blockchain
    </p>
  {/if}
</article>
